<script>
  import miniToastr from "mini-toastr";

  const toastTypes = {
    success: "success",
    error: "error",
    info: "info",
    warn: "warn"
  };

  miniToastr.init({
    types: toastTypes,
    timeout: 4000,
    style: {}
  });

  miniToastr.setIcon("error", "i", {
    class: "icon-error fas fa-exclamation-circle"
  });
  miniToastr.setIcon("info", "i", { class: "icon-info fas fa-info-circle" });
  miniToastr.setIcon("success", "i", {
    class: "icon-success fas fa-check-circle"
  });
  miniToastr.setIcon("warn", "i", {
    class: "icon-warn fas fa-exclamation-triangle"
  });

  /**
   * Mostra a mensagem com o toaster, dependendo do tipo de
   * status.
   *
   */
  const toast = function({ title, message, status, timeout, cb }) {
    if (status === "success") {
      return miniToastr.success(message, title, timeout, cb);
    }
    if (status === "error") {
      return miniToastr.error(message, title, timeout, cb);
    }
    if (status === "info") {
      return miniToastr.info(message, title, timeout, cb);
    }
    if (status === "warn") {
      return miniToastr.warn(message, title, timeout, cb);
    }
  };

  export default {
    toast
  };
</script>

<style>
  #mini-toastr {
    position: fixed;
    z-index: 99999;
    right: 12px;
    top: 12px;
  }
  .mini-toastr__notification {
    cursor: pointer;
    padding: 12px 20px;
    margin: 0 0 6px 0;
    opacity: 0.8;
    border-radius: 3px;
    box-shadow: #bbb 0 0 5px 1px;
    width: 300px;
    color: #344563;
    background-color: #ffffff;
    position: relative;
  }
  .mini-toastr-notification__title {
    font-weight: 700;
    margin-left: 12px;
    color: #353a44;
  }
  .mini-toastr-notification__message {
    display: inline-block;
    vertical-align: middle;
    width: 240px;
    padding: 0 12px;
  }
  .mini-toastr__notification:hover {
    opacity: 1;
    box-shadow: #999 0 0 5px 1px;
  }
  .mini-toastr__notification.-error {
    background-color: #ffebe6;
  }
  .mini-toastr__notification.-warn {
    background-color: #fffae6;
  }
  .mini-toastr__notification.-success {
    background-color: #e3fcef;
  }
  .mini-toastr__notification.-info {
    background-color: #deebff;
  }
  .icon-success {
    color: #00875a;
  }
  .icon-warn {
    color: #ff991f;
  }
  .icon-info {
    color: #0052cc;
  }
  .icon-error {
    color: #de350b;
  }
  .icon-success,
  .icon-warn,
  .icon-info,
  .icon-error {
    top: 14px;
    position: absolute;
    left: 10px;
  }
</style>
